// returns ul and checkbox that publishers must click to certify they agree to the terms

export type StickerPublisherCertificationsProps = {
    setPublisherDidCertify: (certified: boolean) => void;
    publisherDidCertify: boolean;
}

const StickerPublisherCertifications = (props: StickerPublisherCertificationsProps) => {
    const { setPublisherDidCertify, publisherDidCertify } = props;

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPublisherDidCertify(event.target.checked);
    }

    const formPanelClasses = publisherDidCertify
        ? 'mt-4 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 md:px-5 md:py-6 text-left'
        : 'mt-4 rounded-2xl border border-amber-200/80 bg-amber-50/80 px-4 py-4 md:px-5 md:py-6 text-left shadow-[0_0_0_1px_rgba(251,146,60,0.25),0_0_22px_rgba(251,146,60,0.25)]';

    return(
        <div className='w-full text-center'>
            {true && (
                <div className='bg-white pt-5 pb-10 px-2 md:px-10 rounded-2xl border border-slate-200 shadow-sm w-full text-sm'>
                    <h2 className='text-xl font-semibold text-slate-900 text-center'>Complete certification</h2>
                    <div className={formPanelClasses}>
                        <div className='font-semibold text-slate-900'>As the publisher I certify:</div>
                        <ul className='mt-4 list-disc list-inside text-left text-slate-700 space-y-3'>
                            <li>
                                This sticker follows all StickerChain{' '}
                                <a
                                    href="/content-rules"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline decoration-blue-300 hover:text-blue-700"
                                >
                                    content rules
                                </a>
                                .
                            </li>
                            <li>
                                I have rights to use all intellectual property in this sticker.
                            </li>
                            <li>
                                This sticker is awesome.
                            </li>
                        </ul>
                        <label
                            className='mt-8 flex items-center gap-3 text-slate-900 cursor-pointer'
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault();
                                    setPublisherDidCertify(!publisherDidCertify);
                                }
                            }}
                        >
                            <input
                                type='checkbox'
                                checked={publisherDidCertify}
                                onChange={handleCheckboxChange}
                                className='h-5 w-5 accent-emerald-600'
                            />
                            <span className='text-left'>I certify all these things are true.</span>
                        </label>
                    </div>
                </div>
            )}
        </div>
    )
}

export default StickerPublisherCertifications;
